(function () {
const $403bee3f9b165803$var$toggle = document.querySelector(".header-mobile-toggle");
const $403bee3f9b165803$var$header = document.querySelector(".header");
const $403bee3f9b165803$var$hamburger = document.querySelector(".header-mobile-hamburger");
const $403bee3f9b165803$var$mobileLinks = document.querySelector(".header-mobile-links");
const $403bee3f9b165803$var$searchBtn = document.querySelector(".searchButton");
const $403bee3f9b165803$var$searchBtnMobile = document.querySelector(".header-mobile-btns .searchButton");
const $403bee3f9b165803$var$subMenuBtns = document.querySelectorAll(".has-submenu .mc__navbar__trigger");
$403bee3f9b165803$var$toggle?.addEventListener("click", ()=>{
    $403bee3f9b165803$var$hamburger?.classList.toggle("open");
    $403bee3f9b165803$var$searchBtnMobile?.parentElement?.classList.toggle("hide");
    $403bee3f9b165803$var$mobileLinks?.classList.toggle("open");
    $403bee3f9b165803$var$header?.classList.toggle("search-open");
});
$403bee3f9b165803$var$searchBtn?.addEventListener("click", ()=>{
    $403bee3f9b165803$var$searchBtn.parentElement?.classList.toggle("open");
    $403bee3f9b165803$var$header?.classList.toggle("search-open");
});
$403bee3f9b165803$var$searchBtnMobile?.addEventListener("click", ()=>{
    $403bee3f9b165803$var$hamburger?.classList.toggle("open");
    $403bee3f9b165803$var$searchBtnMobile.parentElement?.classList.toggle("hide");
    $403bee3f9b165803$var$mobileLinks?.classList.toggle("open");
    $403bee3f9b165803$var$header?.classList.toggle("search-open");
});
$403bee3f9b165803$var$subMenuBtns?.forEach((btn)=>{
    btn.addEventListener("click", (e)=>{
        e.target?.parentElement?.classList.toggle("open");
    });
});

})();
//# sourceMappingURL=header.js.map
